import React, { useRef, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { TbMovie } from 'react-icons/tb';
import { BiSearch, BiX } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const headerRef = useRef(null);

  const [modalSearch, setModalSearch] = useState(false);

  useEffect(() => {
    const shrinkHeader = () => {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        headerRef.current.classList.add('h-20', 'bg-black');
        headerRef.current.classList.remove('h-32');
      } else {
        headerRef.current.classList.add('h-32');
        headerRef.current.classList.remove('h-20', 'bg-black');
      }
    };
    window.addEventListener('scroll', shrinkHeader);
    return () => {
      window.removeEventListener('scroll', shrinkHeader);
    };
  }, []);
  return (
    <div
      ref={headerRef}
      className={`fixed top-0 h-32 left-0 w-full duration-300 ease-in-out transition-colors z-50 `}
    >
      <>
        <div className="flex flex-row justify-center md:justify-between text-white h-full items-center container mx-auto px-6">
          <Link to={'/'} className="flex flex-row items-center gap-2">
            <TbMovie className="text-yellow-500 w-12 h-auto" />
            <h1 className="text-white font-semibold text-2xl md:text-4xl">
              iMovie
            </h1>
          </Link>
          {/* <div className="md:hidden">
            {!modalSearch ? (
              <BiSearch
                onClick={() => setModalSearch(true)}
                className="w-6 h-6"
              />
            ) : (
              <div className="flex flex-row">
                <input type={'text'} />
                <BiSearch
                  onClick={() => setModalSearch(false)}
                  className="w-7 h-7"
                />
              </div>
            )}
          </div> */}
          <div className="flex flex-row items-center gap-8 text-2xl capitalize font-bold max-md:hidden">
            {['home', 'movies', 'tv'].map((item) => (
              <NavLink
                key={item}
                to={`/${item}` === '/home' ? '/' : `/${item}`}
                className={({ isActive }) =>
                  isActive ? 'text-red-500' : 'text-white'
                }
              >
                {item === 'tv' ? 'TV Series' : item}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="md:hidden fixed inset-x-0 bottom-0 h-16 bg-black flex flex-row items-center justify-between text-base capitalize font-bold px-4">
          {['home', 'movies', 'tv'].map((item) => (
            <NavLink
              key={item}
              to={`/${item}` === '/home' ? '/' : `/${item}`}
              className={({ isActive }) =>
                isActive ? 'text-red-500' : 'text-white'
              }
            >
              {item === 'tv' ? 'TV Series' : item}
            </NavLink>
          ))}
        </div>
      </>
    </div>
  );
};

export default Navbar;
